import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as companyApi from '../api/companyApi';
import { Company } from '../types/company';

export const fetchCompanies = createAsyncThunk(
  'companies/fetchCompanies',
  async (_, { dispatch }) => {
    const companies = await companyApi.getAllCompanies();
    dispatch(loadCompanies(companies));
    return companies;
  }
);

export const saveCompany = createAsyncThunk<
  Company,
  Company,
  { rejectValue: string }
>('companies/saveCompany', async (company, { dispatch, rejectWithValue }) => {
  try {
    const savedCompany = await companyApi.saveCompany(company);

    const updatedCompany = {
      ...company,
      id: savedCompany.id,
      file: null,
      imageId: savedCompany.imageId,
    };

    if (company.id) {
      dispatch(updateCompany(updatedCompany));
    } else {
      dispatch(createCompany(updatedCompany));
    }

    return savedCompany;
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const deleteCompanyAction = createAsyncThunk<
  void,
  string | number,
  { rejectValue: string }
>(
  'companies/deleteCompanyAction',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      await companyApi.deleteCompany(id);
      dispatch(companiesSlice.actions.deleteCompany(id));
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);

const companiesSlice = createSlice({
  name: 'companies',
  initialState: null as Company[] | null,
  reducers: {
    loadCompanies: (state, action: PayloadAction<Company[]>) => {
      return action.payload;
    },
    updateCompany: (state, action: PayloadAction<Company>) => {
      if (state) {
        return state.map((company) =>
          company.id === action.payload.id ? action.payload : company
        );
      }
      return state;
    },
    createCompany: (state, action: PayloadAction<Company>) => {
      if (state) {
        return [...state, action.payload];
      }
      return state;
    },
    deleteCompany: (state, action: PayloadAction<string | number>) => {
      if (state) {
        return state.filter((company) => company.id !== action.payload);
      }
      return state;
    },
  },
});

export const { loadCompanies, updateCompany, createCompany, deleteCompany } =
  companiesSlice.actions;
export default companiesSlice.reducer;
